// Defines main application routes

import { routes } from "./routes";

//Pages

import Error404 from "../components/pages/others/errorPage/Error404";
import SamplePage from "../pages/pages/SamplePage";

import UserInfoAndActivity from "../components/UserDetail/UserInfoAndActivity";
import AllUsersPage from "../components/users/AllUsersPage";
import UserRegisterPage from "../pages/pages/UserRegisterPage";
import UserEditPage from "../components/users/UserEditForm";
import Dashboard from "../components/dashboard/Dashboard";
import UserDetailCard from "../components/users/UserDetailCard";
import InstrumentDetail from "../components/Instruments/InstrumentDetail";
import { elementClosest } from "@fullcalendar/core/internal";
import AddDevices from "../components/Devices/AddDevices";

export const AppRoutes = [
  //Pages
  { path: routes.Sample, element: <SamplePage /> },

  { path: routes.UserLookup, element: <UserInfoAndActivity /> },

  { path: routes.AllUsers, element: <AllUsersPage /> },

  { path: routes.UserEdit, element: <UserEditPage /> },

  { path: routes.UserDashboard, element: <Dashboard /> },

  { path: routes.UserDetail, element: <UserDetailCard /> },

  { path: routes.UserDashboard, element: <Dashboard /> },

  { path: routes.InstrumentDetail, element: <InstrumentDetail /> },

  { path: routes.AddDevice, element: <AddDevices /> },
];

export const AuthRoutes = [
  // Error Pages
  { path: routes.ErrorPages.Error404, element: <Error404 /> },
];
